export default __webpack_public_path__ + "static/media/mt.22c4d64f.svg";